import { cn } from '@/utils/cn';
import { initials } from '@/utils/text';

import styles from './Avatar.module.css';

export interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  /** The person's photo. Without one, their initials show instead. */
  photoUrl?: string | null | undefined;
  className?: string | undefined;
}

/** A person in a circle: their photo, or their initials while there is none. */
export function Avatar({ name, size = 'md', photoUrl, className }: AvatarProps) {
  return (
    <span className={cn(styles.avatar, styles[size], className)} aria-hidden="true">
      {photoUrl ? <img src={photoUrl} alt="" className={styles.photo} /> : initials(name)}
    </span>
  );
}
